
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "sort"
})
export class SortPipe implements PipeTransform {
  transform(collection: Array<any>, sortBy: string, order: string): Array<any> {
    if (!collection || !sortBy) {
      return collection;
    }
    order = order.toLowerCase();

    if (order === "asc") {
      return this.ascendingSort(collection, sortBy);
    } else if (order === "desc") {
      return this.descendingSort(collection, sortBy);
    } else {
      return collection;
    }
  }

  ascendingSort(collection, sortBy): Array<{}> {
    return collection.sort((a, b) => {
      const previous = typeof a[sortBy] === "string" ? a[sortBy].toLowerCase() : a[sortBy];
      const current = typeof b[sortBy] === "string" ? b[sortBy].toLowerCase() : b[sortBy];

      const comparison = previous < current ? -1 : previous > current ? 1 : 0;

      return comparison;
    });
  }

  descendingSort(collection, sortBy): Array<{}> {
    return collection.sort((a, b) => {
      const previous = typeof a[sortBy] === "string" ? a[sortBy].toLowerCase() : a[sortBy];
      const current = typeof b[sortBy] === "string" ? b[sortBy].toLowerCase() : b[sortBy];

      const comparison = current < previous ? -1 : current > previous ? 1 : 0;

      return comparison;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/sort.pipe.ts